/**
 * Where {@link ProtectedRoute} sends someone it turns away from an admin route,
 * and why. The admin sign-in page reads the reason back off the URL, so these
 * are the shared vocabulary of that redirect rather than admin configuration —
 * which is why they can't live in `features/admin/constants`: shared code must
 * not import feature code.
 *
 * They sit in their own module rather than in `ProtectedRoute.tsx` because
 * `react-refresh/only-export-components` forbids a component file from also
 * exporting constants — mixing the two breaks Fast Refresh. `shared/ui/
 * button-variants.ts` is split out from `button.tsx` for the same reason.
 *
 * Every other admin route path stays in `features/admin/constants`; these two are
 * the admin entry points referenced from outside the feature.
 */
export const ADMIN_SIGN_IN_PATH = "/admin/signin";

/**
 * The admin landing page. Shared because impersonation can be stopped from a creator page too, and
 * stopping lands the operator back here as themselves (`useStopSpoofing`).
 */
export const ADMIN_WELCOME_PATH = "/admin/welcome";

/** Query param carrying {@link ADMIN_ACCESS_REDIRECT_REASONS} on the sign-in redirect. */
export const ADMIN_ACCESS_REDIRECT_REASON_PARAM = "reason";

export const ADMIN_ACCESS_REDIRECT_REASONS = {
  NOT_AUTHENTICATED: "notAuthenticated",
  INSUFFICIENT_PERMISSIONS: "insufficientPermissions",
} as const;

export type AdminAccessRedirectReason =
  (typeof ADMIN_ACCESS_REDIRECT_REASONS)[keyof typeof ADMIN_ACCESS_REDIRECT_REASONS];
